import * as React from 'react';
import s from '../../solution-page-views/solution-info/solution-info.scss';
import { Languages } from '@wix/wix-ui-icons-common';
import { composer } from '../../../../component-decorators/composer';
import { PreviewMode } from '../preview-context';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Box, TextButton } from '@wix/design-system';

export interface IDevSiteLinkWrapper extends Partial<WithTranslationProps> {
  href: string;
  children: React.ReactNode;
}

export const DevSiteLinkWrapper = composer()
  .withTranslation()
  .compose((props: IDevSiteLinkWrapper) => {
    return (
      <PreviewMode.Consumer>
        {(value) => {
          return value.isPreview && !props.href ? (
            <Box
              verticalAlign="middle"
              paddingTop={1}
              paddingBottom={1}
              className={s.devCardLinkContainer}
            >
              <TextButton
                size="medium"
                dataHook="developer-email-link"
                prefixIcon={<Languages />}
                as="a"
                href={`https://dev.wix.com/dc3/my-apps/${value.appId}/market/info/basic-info`}
              >
                {props.t('solution.page.preview.addWebSiteURl')}
              </TextButton>
            </Box>
          ) : (
            <div>{props.children}</div>
          );
        }}
      </PreviewMode.Consumer>
    );
  });
